;(function(){

	var layout = function(){

		if (!$site.page.wrapper) return false;

		// Clear any styles set that may be undone
		TweenLite
			.set($site.page.wrapper, {
				clearProps: 'minHeight'
			});

		// Is the friends of yorkshire tea panel on the page?
		var friends = $site.letsBeFriends.length;

		// Set the min height of the page wrapper
		TweenLite
			.set($site.page.wrapper, {
				minHeight: site.height - ( $site.footer.outerHeight() + ( friends ? $site.letsBeFriends.outerHeight() : 0 ) )
			});

	};

	// Add to the site resize
	site.resize.after['layout'] = layout;

	// On ready
	layout();

	// On load
	$core.win.load(layout);

}());